"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.formatSchedule = exports.formatScheduleHour = void 0;
var moment = require("moment");
moment.locale('ro');
var formatScheduleHour = function (hour) {
    var formattedHour = moment()
        .startOf('day')
        .add(hour % 24, 'hours')
        .format('H:mm');
    if (formattedHour === '0:00') {
        return '24:00';
    }
    return hour >= 24 ? "".concat(formattedHour, " AM") : formattedHour;
};
exports.formatScheduleHour = formatScheduleHour;
function formatSchedule(schedule) {
    if (!(schedule === null || schedule === void 0 ? void 0 : schedule.length)) {
        return [];
    }
    var days = ['L', 'Ma', 'Mi', 'Jo', 'V', 'S', 'D'];
    // Group by hours
    var grouped = {};
    var closedDays = [];
    for (var _i = 0, schedule_1 = schedule; _i < schedule_1.length; _i++) {
        var _a = schedule_1[_i], dayIndex = _a.dayIndex, openHour = _a.openHour, closeHour = _a.closeHour, closedAllDay = _a.closedAllDay;
        if (closedAllDay) {
            closedDays.push(dayIndex);
            continue;
        }
        var hoursKey = "".concat((0, exports.formatScheduleHour)(openHour), "-").concat((0, exports.formatScheduleHour)(closeHour));
        if (!grouped[hoursKey]) {
            grouped[hoursKey] = [];
        }
        grouped[hoursKey].push(dayIndex);
    }
    // Helper to convert array of day indices to a string
    var formatDayRange = function (daysArray) {
        var result = '';
        var start = daysArray[0];
        var end = daysArray[0];
        for (var i = 1; i < daysArray.length; i++) {
            if (daysArray[i] === end + 1) {
                end = daysArray[i];
            }
            else {
                result += (start === end ? days[start - 1] : "".concat(days[start - 1], "-").concat(days[end - 1])) + ',';
                start = daysArray[i];
                end = daysArray[i];
            }
        }
        result += start === end ? days[start - 1] : "".concat(days[start - 1], "-").concat(days[end - 1]);
        return result;
    };
    // Format output
    var result = Object.entries(grouped).map(function (_a) {
        var hours = _a[0], daysArray = _a[1];
        var dayString = formatDayRange(daysArray);
        return { dayString: dayString, hoursString: hours };
    });
    if (closedDays.length > 0) {
        var closedDayString = formatDayRange(closedDays);
        result.push({ dayString: closedDayString, hoursString: 'Închis' });
    }
    result = result.sort(function (a, b) {
        var aIndex = days.indexOf(a.dayString.split('-')[0]);
        var bIndex = days.indexOf(b.dayString.split('-')[0]);
        return aIndex - bIndex;
    });
    if (result.length < 2) {
        result = result.map(function (x) { return (__assign(__assign({}, x), { hoursString: x.hoursString.replace(/-/g, ' - ') })); });
    }
    if (result.length > 2) {
        result = result.map(function (x) { return (__assign(__assign({}, x), { hoursString: x.hoursString.replace(/:00/g, '') })); });
    }
    return result;
}
exports.formatSchedule = formatSchedule;
